<template>
  <div
    id="security"
    class="system-info"
  >
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'SecurityView',
};
</script>

<style lang="scss" scoped>
.system-info {
  overflow: auto;
  height: 100%;
}
</style>